{
  "GENERAL": {
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Αναζήτηση",
      "EMPTY_STATE": "Δεν βρέθηκαν αποτελέσματα"
    },
    "CLOSE": "Κλείσιμο",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "This feature is in beta and may change as we improve it.",
    "ACCEPT": "Accept",
    "DISCARD": "Discard",
    "PREFERRED": "Preferred"
  },
  "CHOICE_TOGGLE": {
    "YES": "Ναι",
    "NO": "Όχι"
  }
}
